
import About from '../Components/About/page'
import Banner from '../Components/Banner/page'
import Barbar from '../Components/Barbar/page'
// import API from '../API/page'
import Contact from '../Components/Contact/page'
import Footer from '../Components/Footer/Footer'
import Gallery from '../Components/Gallery/page'
import Header from '../Components/Header/page'
import Services from '../Components/Services/page'
import React from 'react'

const Home = () => {
  return (
    <>
    <Header />
      <Banner/>
      <About />
      <Barbar />
      {/* <API /> */}
      <Gallery />
      <Services />
      <Contact />
      <Footer />
    </>
  )
}

export default Home